import type { ComponentType } from 'react'
import { YeshumanBrandMark } from '@/components/landing/yeshuman/yeshuman-brand-mark'
import { getPluginSlots } from '@/plugin/slots'
import type { AuthBrandMarkProps as MarkProps, AuthBrandMarkSize } from '@/plugin/types'

export type { AuthBrandMarkSize }

const AUTH_BRAND_MARKS: Record<string, ComponentType<MarkProps>> = {
  yeshumanWordmark: YeshumanBrandMark,
}

type AuthBrandMarkProps = {
  markKey: string
  className?: string
  size?: AuthBrandMarkSize
}

export function AuthBrandMark({ markKey, className, size = 'md' }: AuthBrandMarkProps) {
  const Mark = getPluginSlots().authBrandMarks[markKey] ?? AUTH_BRAND_MARKS[markKey]
  if (!Mark) return null
  return <Mark navigateHome size={size} className={className} />
}
